import { AttioQuoteMigrationPreview, AttioQuoteMigrationStatus } from "src/api-service";

// **************************************************************************
// ATTIO QUOTE MIGRATION STATE
// **************************************************************************
export interface AttioQuoteMigrationLoadingState {
    loadingPreview: boolean;
    starting: boolean;
}

export interface AttioQuoteMigrationState {
    preview: AttioQuoteMigrationPreview | undefined;
    /** The current or last run; undefined until the API has been asked. */
    status: AttioQuoteMigrationStatus | undefined;
    loading: AttioQuoteMigrationLoadingState;
}

export const initialAttioQuoteMigrationState: AttioQuoteMigrationState = {
    preview: undefined,
    status: undefined,
    loading: { loadingPreview: false, starting: false },
};
